<template>
  <div>
    <div class="h-panel">
      <b-button v-b-modal.help-modal>Help</b-button>
    </div>

    <loading-indicator
      v-if="isLoading"
    />

    <p v-if="message !== null">
      {{message}}
    </p>

    <template v-if="isLoaded && members !== null && members.length > 0">
      <h4>Members</h4>
      <table class="table text-nowrap">
        <thead class="thead-dark">
          <tr>
            <th scope="col">Id</th>
            <th scope="col">Name</th>
            <th scope="col">Leader</th>
            <th scope="col">Level</th>
            <th scope="col">Joined</th>
            <th scope="col">Membership duration (days)</th>
            <th scope="col">Week help</th>
            <th scope="col">Activity rating</th>
          </tr>
        </thead>

        <member
          v-for="member in members"
          :key="member.player_id"
          :member="member"
          :isLeader="member.player_id === ownerId"
          :now="nowSec"
        />
      </table>
    </template>

    <b-modal id="help-modal" title="Help" ok-only ok-title="Close">
      <div class="help">
        <p>
          На данной странице показаны все участники клуба.
          Участники клуба упорядочены по меньшению уровня.
        </p>

        <h5>Рейтинг активности</h5>
        <p>
          Рейтинг активности участника клуба (activity rating) вычисляется по следующей формуле.
        </p>
        <p>
          (количество дней в клубе) * (количество отправленных жизней за последние 7&nbsp;дней)
        </p>
        <p>
          Рейтинг активности участника клуба используется при&nbsp;автоматическом изменении лидера клуба
          (при&nbsp;выборе нового лидера клуба).
        </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { HTTP } from '../http-common.js';

import { LOAD_STATE_INIT    } from '../util.js';
import { LOAD_STATE_LOADING } from '../util.js';
import { LOAD_STATE_LOADED  } from '../util.js';

import notifier from '../notifier.js';
import LoadingIndicator from './LoadingIndicator.vue';
import Member from './ClubMembers/Member.vue';

export default {
  name: 'ClubMembers',

  components: {
    LoadingIndicator,
    Member,
  },

  props: {
    clubId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,
      ownerId: null,
      members: null,

      nowSec: Date.now() / 1000,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    /** @returns {boolean} */
    isLoaded() {
      return this.loadState === LOAD_STATE_LOADED;
    },

    /** @returns {?string} */
    message() {
      if(this.isLoaded && this.members === null) {
        return 'Club not found.';
      }
      return null;
    },
  },

  created() {
    notifier.deleteSenderNotifications(this);

    this.loadState = LOAD_STATE_LOADING;
    HTTP.get('/club/' + this.clubId + '/members')
    .then(response => {
      const data = response.data.data;
      if(data === null) {
        return;
      }

      this.ownerId = data.ownerId;

      const members = [];
      for(let i = 0; i < data.members.length; i++) {
        const member = data.members[i];
        members.push(member);
      }
      members.sort((a, b) => b.level - a.level);
      this.members = members;
    })
    .catch(e => {
      notifier.showError(e.response.data, {sender: this});
    })
    .finally(() => {
      this.loadState = LOAD_STATE_LOADED;
    });
  },
};
</script>
